import styles from "./NoticeText.module.less";

const NoticeText = ({ text }) => {
  return (
    <div className={styles["notice-box"]}>
      <div className={styles["notice-box-text"]}>
        {text}
      </div>
    </div>
  );
};

export default NoticeText;